module.exports = __webpack_public_path__ + "static/media/invoice.3cc05a2e.png";